import React from "react";
import { Table } from "antd";

export default function TableView({ columns = [], rows = [] }) {
  const dataSource = rows.map((row, index) => ({ key: index, ...row }));

  const antColumns = columns.map((col) => ({
    title: col.label,
    dataIndex: col.key,
    key: col.key,
    sorter: (a, b) => {
      const av = a[col.key];
      const bv = b[col.key];
      if (typeof av === "number" && typeof bv === "number") return av - bv;
      return String(av || "").localeCompare(String(bv || ""));
    },
  }));

  return <Table columns={antColumns} dataSource={dataSource} scroll={{ x: true }} />;
}
